import { RequestManager } from "../utils/request";

const { default: BaseInterpreterProvider } = require("./BaseProvider");

class WebProvider extends BaseInterpreterProvider {
  constructor(baseUrl = "") {
    super();

    this.baseUrl = baseUrl;
    this.requestManager = new RequestManager(this.baseUrl);
  }

  CALL_OPTION_KEYS = {
    "Audio Only": "AUDIO_ONLY",
    "Video Only": "VIDEO_ONLY",
    "Video Preferred": "VIDEO_PREFERRED",
  };

  GENDER_OPTION_KEYS = {
    "Male Only": "MALE_ONLY",
    "Female Only": "FEMALE_ONLY",
    "Male Preferred": "MALE_PREFERRED",
    "Female Preferred": "FEMALE_PREFERRED",
    "No Preference": "NO_PREFERRENCE",
  };

  async getConfiguration() {
    try {
      const configuration = {};
      const url = `/configurations`;
      const res = await this.requestManager.request(
        url,
        "GET",
        "getConfiguration"
      );

      configuration["genderSelectionOption"] = [];
      configuration["callTypeOptions"] = [];
      configuration["languageList"] = [];
      configuration["estimatedTime"] = true;
      configuration["globoLanguageList"] = false;
      // save configuration
      const datalists = res?.datalists;
      const options = res?.options;
      let languageList = null;
      let genderOptionData = null;
      let confrenceTypeData = null;
      for (let data of datalists) {
        if (data?.listName === "conferenceoptions") {
          confrenceTypeData = data?.data;
          confrenceTypeData.forEach((item, index, array) => {
            item.text = this.CALL_OPTION_KEYS[item.text];
          });
          configuration["callTypeOptions"] = confrenceTypeData;
        }
        if (data?.listName === "genderoptions") {
          genderOptionData = data?.data;
          genderOptionData.forEach((item, index, array) => {
            item.text = this.GENDER_OPTION_KEYS[item.text];
          });
          configuration["genderSelectionOption"] = genderOptionData;
        }
        if (data?.listName === "languagelist") {
          languageList = data?.data;

          configuration["languageList"] = languageList;
        }
      }
      if (options?.estimatedTime === false) {
        configuration["estimatedTime"] = false;
      }
      if (options?.globoLanguageList === true) {
        configuration["globoLanguageList"] = true;
      }
      return configuration;
    } catch (error) {
      console.error(`Error while getting configuration`, error);
      return error;
    }
  }

  async sendInvite(payload) {
    const url = `/invite`;
    const body = JSON.stringify({
      languageId: payload?.languageId || 44,
      conferenceType: payload?.conferencType || "",
      genderOption: payload?.genderOption || "",
      meetingRoomPin: payload?.meetingRoomPin || "",
      meetingPortal: payload?.meetingPortal || "",
      meetingRoomId: payload?.meetingRoomId || "",
    });
    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "invite",
        body
      );
      const inviteResponse = {};
      inviteResponse["RequestId"] = res.session;
      inviteResponse["status"] = res.successful;
      return inviteResponse;
    } catch (error) {
      const inviteResponse = {};
      const ERROR_MESSAGE =
        error?.response?.data?.message || "error occured during invite";
      inviteResponse["errorMessage"] = ERROR_MESSAGE;
      inviteResponse["status"] = error?.successful || false;
      console.error(JSON.stringify(error));
      return inviteResponse;
    }
  }

  async getInviteStatus(requestID) {
    const url = `/sessions/${requestID}`;
    try {
      const res = await this.requestManager.request(url, "GET", "InviteStatus");
      const statusResponse = {};
      statusResponse["successful"] = res.successful;
      statusResponse["code"] = res.data?.status || null;
      statusResponse["roomId"] = res.data?.roomId || null;
      statusResponse["trackingNumber"] = res.data?.trackingNumber || null;
      statusResponse["interpreterId"] = res.data?.participantId || null;
      statusResponse["interpreterName"] = res.data?.participantName || null;
      statusResponse["estimatedTime"] =
        res.provider?.EstimationTimeString || "";
      return statusResponse;
    } catch (error) {
      console.error(
        "error occured while getting invite status ",
        JSON.stringify(error)
      );
      const statusResponse = {};
      const ERROR_MESSAGE =
        error?.response?.data?.message ||
        "error returned while querying invitation status";

      statusResponse["successful"] = error?.successful || false;
      statusResponse["errorMessage"] = ERROR_MESSAGE;
      return statusResponse;
    }
  }

  async completeInviteRequest(requestID) {
    const url = `/sessions/${requestID}/leave`;
    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "interpreterLeft"
      );
      return res;
    } catch (error) {
      return console.error(
        "error while completeing the invite request",
        JSON.stringify(error)
      );
    }
  }

  async interpreterJoin(payload) {
    const url = `/sessions/${payload.sessionId}/join`;
    const body = JSON.stringify({
      participantid: payload.id,
      participantname: payload.name,
    });
    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "interpreterJoined",
        body
      );
      return res;
    } catch (error) {
      console.error(
        "error occured when interpreter joined the call ",
        JSON.stringify(error)
      );
      return error?.response?.data;
    }
  }

  async interpreterLeft(sessionId) {
    const url = `/sessions/${sessionId}/leave`;
    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "interpreterLeft"
      );
      return res;
    } catch (error) {
      console.error(
        "error occured when interpreter leave the call ",
        JSON.stringify(error)
      );
      return error?.response?.data;
    }
  }
}

export default WebProvider;
